module.exports = __webpack_public_path__ + "static/media/hero-learn.679a94f3.png";